import { Helmet } from 'react-helmet-async';

const LOGO_URL = "/coyp-logo.png";
const SITE_NAME = "Check On Yo Peoples TV";

const SEO = ({ 
  title, 
  description, 
  image, 
  url,
  type = 'article' 
}) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const pageDesc = description || "Cincinnati's Source for News and Entertainment";
  const pageImage = image || LOGO_URL;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title || SITE_NAME} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:image" content={pageImage} />
      {url && <meta property="og:url" content={url} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || SITE_NAME} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={pageImage} />
    </Helmet>
  );
};

export default SEO;
